import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {getHealthcareData} from '/redux/action/coach.action';
import {
  hasHealthcareData,
  hasHealthcareError,
  healthcareData,
  isHealthcareSaving,
} from '/redux/selector/coach.selector';

import {HealthcareProviderScreen} from './HealthcareProviderScreen';

const mapStateToProps = createStructuredSelector({
  healthcareData,
  healthcareSaving: isHealthcareSaving,
  hasHealthcareData,
  hasHealthcareError,
});

const mapDispatchToProps = (dispatch: any) => ({
  getHealthcareData: () => dispatch(getHealthcareData({})),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HealthcareProviderScreen);
